export const EXAM_PLAN_XAPI_CONTENT = {
    extraContent: {
        gnb: "HOM",
        lnbNm1: "시험대비모드 레이어 팝업",
        lnbCd1: "EPM",
        path: "B",
    },
};

export const HOME_XAPI_CONTENT = {
    extraContent: {
        gnb: "HOM",
    },
};
